// Edit these before publishing — they appear in the Privacy Policy.
export const SITE_NAME = "Open-Wrecks";
export const POLICY_UPDATED = "October 6, 2026"; // Terms and Conditions
export const PRIVACY_UPDATED = "October 10, 2026"; // Privacy Policy
export const CONTACT_URL = "https://github.com/alfredredbird/open-wrecks/issues"; // TODO: your repo / contact page
export const CONTACT_LABEL = "our GitHub issues page";
export const REPO_URL = "https://github.com/alfredredbird/open-wrecks";

// Social links shown on the Contact page.
export const SOCIALS = [
  { key: "x", label: "X", handle: "@alfredredbird1", url: "https://x.com/alfredredbird1" },
  { key: "reddit", label: "Reddit", handle: "u/alfredredbird", url: "https://www.reddit.com/user/alfredredbird" },
];

// Shows a dismissible "not fully ready for mobile" notice on phone-sized screens.
// Set to false once you're happy with the mobile experience. Bump the version to show it again to everyone who dismissed it.
export const SHOW_MOBILE_WARNING = true;
export const MOBILE_WARNING_VERSION = 1;

// Shown in the "Needs work" filter. Keep in sync with POINTS.edit in functions/_shared/points.js.
export const POINTS_PER_EDIT = 3;
